import { Col, InputRef, Row } from 'antd';
import Text from 'components/Text';
import { useMemo, useState } from 'react';
import shopSelectors from 'services/shop/selectors';
import {
  ICustomerItemData,
  ICustomerItemDataOpt,
} from 'services/shop/types/customer';
import styled from 'styled-components';
import ButtonAddCustomer from '../AddCustomer';
// import CustomerSearchInput from '../CustomerSearchInput';
import CustomerItem from './CustomerItem';
// import { UNKNOWN_CUSTOMER } from 'features/cashier/services/constants';
import CustomerSearchInput from '../CustomerSearchInputV2';
import colorTheme from 'constants/color';
import Box from 'components/Box';
import IcAccountV2 from 'assets/Icons/IcAccountV2';
import icCheckbox from 'components/Checkbox/ic_checkbox.svg';
import icCheckboxActive from 'components/Checkbox/ic_checkbox-active.svg';

export type ChooseCustomerFormProps = {
  onPickCustomer?: (cus: ICustomerItemData) => void;
  inputRef: React.RefObject<InputRef>;
  customer?: ICustomerItemData;
  recentList?: ICustomerItemData[];
  onChooseUnknown?: () => void;
  v2?: boolean;
};
const ChooseCustomerForm = ({
  v2,
  inputRef,
  customer,
  onPickCustomer = () => undefined,
  onChooseUnknown,
}: ChooseCustomerFormProps) => {
  const customers = shopSelectors.data.customers();
  const [searchText] = useState('');

  const initOptions = useMemo(() => {
    return customers.map((o) => ({
      ...o,
      label: o.name || '',
      value: o.id,
      keyword: o.name?.toLowerCase() || '',
    }));
  }, [customers]);

  // const recentListOptions = useMemo(() => {
  //   return recentList.map(o => ({
  //     ...o,
  //     label: o.name,
  //     value: o.id,
  //     keyword: o.name.toLowerCase(),
  //   }));
  // }, [recentList]);

  const options = useMemo(() => {
    if (!searchText.trim()) return initOptions;

    return initOptions.filter((item) =>
      item.keyword.includes(searchText.toLowerCase()),
    );
  }, [initOptions, searchText]);

  return (
    <ChooseCustomerFormStyled style={{ zoom: v2 ? 1.5 : 1 }}>
      <Row gutter={16} className='sticky-box'>
        <Col flex={'auto'} style={{ marginLeft : '-16px' }}>
          <CustomerSearchInput
            value={customer}
            onChange={(data) => {
              if (data) {
                onPickCustomer(data);
              }
            }}
          />
        </Col>
        <Col>
          <ButtonAddCustomer model='new-ticket' v2/>
        </Col>
      </Row>
      <Text mb={1.5} />
      {customer && (
        <UnkownCustomerContainer
          className={`${!customer?.id ? 'selected' : ''}`}
          onClick={() => {
            onChooseUnknown?.();
          }}
        >
          <Box
            display='flex'
            alignItems='center'
            justifyContent='center'
            width='64px'
            height='64px'
            borderRadius='100%'
            bgColor='text_1'
          >
            <IcAccountV2 />
          </Box>
          <Box
            display='flex'
            flexDirection='column'
            justifyContent='center'
            gap='1'
            width='100%'
          >
            <Text variant='H5'>Unknown Customer</Text>
            <Text variant='H8' color='text_3' style={{ fontWeight: '500' }}>
              Continue without customer details
            </Text>
          </Box>
          {!customer?.id ? (
            <img
              src={icCheckboxActive}
              alt='checkbox'
              style={{ width: 32, height: 32 }}
            />
          ) : (
            <img
              src={icCheckbox}
              alt='checkbox'
              style={{ width: 32, height: 32 }}
            />
          )}
        </UnkownCustomerContainer>
      )}
      <Text mb={1.5} />
      <Text variant='H5'>All Customer</Text>
      <ListContainer>
        {options.map((item: ICustomerItemDataOpt) => {
          return (
            <CustomerItem
              key={item.id}
              data={item}
              onClick={() => onPickCustomer(item)}
              selected={customer?.id === item.id}
            />
          );
        })}
      </ListContainer>
    </ChooseCustomerFormStyled>
  );
};

export default ChooseCustomerForm;
const ChooseCustomerFormStyled = styled.div`
  .container {
    padding: 0 1rem;
  }
`;
const ListContainer = styled.div`
  padding-top: 1rem;
  overflow: auto;

  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1rem;
`;

const UnkownCustomerContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 12px 24px;
  border-radius: 12px;
  border: 1px solid ${colorTheme.v2_border_2};
  background: ${colorTheme.v2_neutral_3};
  cursor: pointer;

  &.selected {
    border: 1px solid ${colorTheme.v2_secondary_3};
    background: ${colorTheme.v2_secondary_1};
  }
`;
